import { render, staticRenderFns } from "./NewEjare.vue?vue&type=template&id=2b39e7fa&scoped=true"
import script from "./NewEjare.vue?vue&type=script&lang=js"
export * from "./NewEjare.vue?vue&type=script&lang=js"
import style0 from "./NewEjare.vue?vue&type=style&index=0&id=2b39e7fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b39e7fa",
  null
  
)

export default component.exports